import { request } from "../../utils/request";

export const getFastTranslatePresignedUrlsApi = (body: FastTranslateSeries.GetPresignedUrlsPayload) => {
  return request<FastTranslateSeries.GetPresignedUrlsResponse>("/video/fast-translate-series/presigned-urls", {
    method: "POST",
    body,
  });
};

export const confirmFastTranslateUploadApi = (body: FastTranslateSeries.ConfirmUploadPayload) => {
  return request<FastTranslateSeries.ConfirmUploadResponse>("/video/fast-translate-series/confirm-upload", {
    method: "POST",
    body,
  });
};

export const createFastTranslateSeriesApi = (body: FastTranslateSeries.CreateFastTranslateSeriesPayload) => {
  return request<FastTranslateSeries.CreateFastTranslateSeriesResponse>("/video/fast-translate-series/create", {
    method: "POST",
    body,
  });
};

export const getFastTranslateSeriesPageApi = (params: {
  pageNo: number;
  pageSize: number;
  name?: string;
  sort?: number;
  /** 1 团队剧集，2 普通用户剧集；不传则不带 ownerType（与列表「全部」范围对齐） */
  ownerType?: number;
}) => {
  const { pageNo, pageSize, name, sort, ownerType } = params;
  const query: Record<string, any> = {
    pageNo,
    pageSize,
  };
  if (typeof ownerType === "number") {
    query.ownerType = ownerType;
  }
  if (typeof sort === "number") query.sort = sort;
  if (name && name.trim()) query.name = name.trim();
  return request<FastTranslateSeries.FastTranslateSeriesPageResponse>("/video/fast-translate-series/page", {
    method: "GET",
    params: query,
  });
};

export const getFastTranslateSeriesItemTargetLangPageApi = (params: {
  pageNo: number;
  pageSize: number;
  seriesId: number;
  name?: string;
  sort?: number;
}) => {
  const { pageNo, pageSize, seriesId, name, sort } = params;
  const query: Record<string, any> = { pageNo, pageSize, seriesId };
  if (typeof sort === "number") query.sort = sort;
  if (name && name.trim()) query.name = name.trim();
  return request<FastTranslateSeries.FastTranslateSeriesItemTargetLangPageResponse>(
    "/video/fast-translate-series/item/target-lang/page",
    {
      method: "GET",
      params: query,
    }
  );
};

export const deleteFastTranslateSeriesApi = (params: {
  id: number;
  targetLangCode?: string;
}) => {
  return request<FastTranslateSeries.DeleteFastTranslateSeriesResponse>("/video/fast-translate-series/delete", {
    method: "DELETE",
    params,
  });
};

export const getFastTranslateSeriesItemListApi = (params: {
  seriesId: number;
  targetLangCode?: string;
  keyword?: string;
  sort?: number;
}) => {
  const { seriesId, targetLangCode, keyword, sort } = params;
  const query: Record<string, any> = { seriesId };
  if (targetLangCode) query.targetLangCode = targetLangCode;
  if (keyword && keyword.trim()) query.keyword = keyword.trim();
  if (typeof sort === "number") query.sort = sort;
  return request<FastTranslateSeries.FastTranslateSeriesItemListResponse>(
    "/video/fast-translate-series/item/list",
    {
      method: "GET",
      params: query,
    }
  );
};

export const renameFastTranslateSeriesApi = (body: {
  seriesId?: number;
  id?: number;
  name: string;
}) => {
  return request<FastTranslateSeries.RenameFastTranslateSeriesResponse>("/video/fast-translate-series/rename", {
    method: "PUT",
    body,
  });
};

export const deleteFastTranslateUploadBatchApi = (body: {
  uploadBatchNos: string[];
}) => {
  return request<FastTranslateSeries.DeleteFastTranslateUploadBatchResponse>("/video/fast-translate-series/upload/batch/delete", {
    method: "DELETE",
    body,
  });
};

export const deleteFastTranslateUploadItemApi = (body: {
  uploadBatchNo: string;
  filePath: string;
  coverFilePath: string;
}) => {
  return request<FastTranslateSeries.DeleteFastTranslateUploadItemResponse>("/video/fast-translate-series/upload/delete", {
    method: "DELETE",
    body,
  });
};

export const deleteFastTranslateSeriesItemApi = (params: {
  seriesId: number;
  itemId: number;
}) => {
  return request<FastTranslateSeries.DeleteFastTranslateSeriesItemResponse>("/video/fast-translate-series/item/delete", {
    method: "DELETE",
    params,
  });
};

export const addFastTranslateSeriesTargetLangsApi = (body: FastTranslateSeries.AddTargetLangsPayload) => {
  return request<FastTranslateSeries.AddTargetLangsResponse>("/video/fast-translate-series/add-target-langs", {
    method: "POST",
    body,
  });
};

